import React from 'react';
import './PaymentSuccessScreen.scss';
import pageTextConfig from '../../../../assets/configs/Payment Screens/PaymentSuccessfulScreen/textConfig';
import Navbar from '../../../CommonComponents/Navbar/Navbar';
import Lottie from 'lottie-react';
import successLottie from '../../../../assets/lottie_animations/success-lottie.json';
import { Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDateFromTimeStamp } from '../../../../utils/DateAndTimeUtils';
import { Order } from '../../../../Models/Order';

const PaymentSuccessScreen: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { order } = location.state || {} as { order: Order};

  const onCheckOrdersClicked = () => {
    navigate('/my-orders');
  };

  const onContinueShoppingClicked = () => {
    navigate('/categories');
  };

  return (
    <div className="payment-success-screen-root">
      <Navbar useScrollVersion={true} />

      <div className="all-content">
        <div className="order-container">
          <div className="order-success-container">
            <Lottie className="success-lottie" animationData={successLottie} loop={true} />
            <Typography className="order-success-heading" variant="h4" fontWeight={600}>
              Order Successful
            </Typography>
            <Typography className="transaction-n-order-id" variant="h6">
              Transaction ID: <b>#{order.paymentMeta.recievedPaymentId}</b> Order ID: <b>#{order.id}</b>
            </Typography>
          </div>

          <div className="delivery-info-container">
            <div className="delivery-info-content">
              <div className="estimated-delivery-container">
                <Typography className="delivery-details-title" variant="h5" fontWeight={600}>
                  Estimated Delivery
                </Typography>
                <Typography className="delivery-details-time" variant="h6" fontWeight={400}>
                  {order.deliveryTimeStamp
                    ? new Date(order.deliveryTimeStamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                    : ''}
                </Typography>
                <Typography className="delivery-details-date" variant="h6" fontWeight={400}>
                  {order.deliveryTimeStamp
                    ? getDateFromTimeStamp(order.deliveryTimeStamp).toUpperCase()
                    : ''}
                </Typography>
              </div>

              <div className="buttons-container">
                <button className="check-orders" onClick={onCheckOrdersClicked}>
                  {pageTextConfig.checkOrdersButton}
                </button>
                <button className="continue-shopping" onClick={onContinueShoppingClicked}>
                  {pageTextConfig.continueShoppingButton}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessScreen;
